export class AuditFilter {

    constructor(
        public companyOid?: number,
        public page?: number,
        public offset?: number,
        public action?: string,
        public language?: string,
        public filterPeriod = {
            from: null,
            to: null
        }

) {  }

}



// WEBPACK FOOTER //
// ./public/upgrade/feature/audit/audit-filter.ts